<template>
    <el-tag
        v-bind="$attrs"
        v-on="$listeners"
        :size="tagSize"
        :type='tagType'
        class="dap-tag">
            <template slot="default">
                <slot name="default"></slot>
            </template>
    </el-tag>
</template>
<script>
export default {
    name: 'DapTag',
    inheritAttrs: false,
    props: {
        type: {},
        colorType: {
            type: String,
            default: 'blue',
            validator: value => ['blue', 'green', 'gray', 'red', 'yellow'].indexOf(value) > -1
        },
        size: {
            type: String,
            default: 'mini',
        },
    },
    data () {
        return {
            sizeMap: {
                default: '',
                medium: 'medium',
                small: 'small',
                mini: 'mini',
            },
            colorTypeMap: {
                blue: '',
                green: 'success',
                gray: 'info',
                red: 'danger',
                yellow: 'warning',
            }
        };
    },
    computed: {
        tagSize () {
            return this.sizeMap[this.size];
        },
        tagType () {
            return this.colorTypeMap[this.colorType];
        },
    },
}
</script>

<style lang="scss">
.dap-tag.el-tag {
    border-radius: 2px;

    &.el-tag--mini {
        height: 20px;
        line-height: 18px;
    }
}
</style>
